/* eslint-disable */
import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default props => {
  return (
    <SvgIcon {...props}>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="home"
          transform="translate(-251.000000, -737.000000)"
          stroke="currentColor"
        >
          <g
            id="iPhone-X/Bars/Tab-Bar/5-Items"
            transform="translate(0.000000, 722.000000)"
          >
            <g id="Item-4" transform="translate(238.000000, 9.000000)">
              <g id="Icon">
                <g id="Group-907" transform="translate(14.000000, 7.000000)">
                  <path
                    d="M19.9074074,8.77192982 C19.9074074,13.3745614 18.4564815,17.1052632 16.6666667,17.1052632 C14.8768519,17.1052632 13.4259259,13.3745614 13.4259259,8.77192982 C13.4259259,4.16929825 14.8768519,0.438596491 16.6666667,0.438596491 C18.4564815,0.438596491 19.9074074,4.16929825 19.9074074,8.77192982 L19.9074074,8.77192982 Z"
                    id="Stroke-899"
                  ></path>
                  <path
                    d="M16.2037037,6.57894737 C17.2268519,6.57894737 18.0555556,7.56052632 18.0555556,8.77192982 C18.0555556,9.98333333 17.2268519,10.9649123 16.2037037,10.9649123"
                    id="Stroke-901"
                  ></path>
                  <path
                    d="M15.0914815,1.49192982 L8.79611111,5.70157895 L3.70351852,5.70157895 C1.9137037,5.70157895 0.462777778,7.07614035 0.462777778,8.77175439 C0.462777778,10.4673684 1.9137037,11.8419298 3.70351852,11.8419298 L8.79611111,11.8419298 L15.0914815,16.0515789 C14.097963,14.6278947 13.4257407,11.9033333 13.4257407,8.77175439 C13.4257407,5.64017544 14.097963,2.91561404 15.0914815,1.49192982 L15.0914815,1.49192982 Z"
                    id="Stroke-903"
                  ></path>
                  <path
                    d="M3.24074074,11.8421053 L5.09259259,13.5964912 L5.09259259,17.0438596 C5.09259259,17.6298246 5.40185185,18.1780702 5.91759259,18.5035088 L7.87037037,19.7368421 L8.2537037,19.3736842 C8.60092593,19.0447368 8.7962963,18.5982456 8.7962963,18.1333333 L8.7962963,17.8315789 C8.7962963,17.3666667 8.60092593,16.9201754 8.2537037,16.5912281 L8.25185185,16.5903509 C8.01388889,16.3640351 7.91018519,16.0394737 7.97592593,15.7263158 L8.7962963,11.8421053 C7.00648148,11.8421053 6.01851852,10.4675439 6.01851852,8.77192982 C6.01851852,7.07631579 7.00648148,5.70175439 8.7962963,5.70175439"
                    id="Stroke-905"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};
